import React from 'react'
import { Fields } from 'redux-form'
import { useTranslation } from 'react-i18next'

import {
  StyledWrapper,
  StyledSubheading,
} from './package-content.component.styles'

import { ConnectedPackageDetailsAutoComplete } from '../package-details-autocomplete.component'

const PackageContent = () => {
  const [t] = useTranslation()

  return (
    <StyledWrapper>
      <StyledSubheading>
        {t('orders.new.basicInfo.subtitle.packageContent')}
      </StyledSubheading>
      <Fields
        names={[
          'info',
          'length',
          'width',
          'height',
          'weight',
          'remark',
          'image.secret',
          'size_option',
        ]}
        dataTestid="delivery-order-package-details-autocomplete"
        placeholder={t('orders.new.basicInfo.placeholder.packageDescription')}
        component={ConnectedPackageDetailsAutoComplete}
      />
    </StyledWrapper>
  )
}

export { PackageContent }
